//
import axios from "axios";
import config from "../config";
import { ChannelsResponse } from "./ResponseModels/ChannelsResponse";
import { FakeAxiosResponse } from "./FakeAxiosResponse";
import ChannelsResponseFake from "./json/ChannelsResponseFake.json";

export async function GetChannelsModel() {
  let response = null;
  if (!config.useFakeModels) {
    response = axios
      .get<ChannelsResponse>(config.getFormEndpoint, {})
      .catch((e) => {
        // TODO manage
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(ChannelsResponseFake));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
